import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import { updateMeta } from "../../../store/actions/metaAction";
import { useHistory } from "react-router";

import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const InformationShow = ({ match }) => {
	const {
		params: { informationId },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [firstTitle, setFirstTitle] = useState("");
	const [secondTitle, setSecondTitle] = useState("");
	const [thirdTitle, setThirdTitle] = useState("");
	const [firstTitleEn, setFirstTitleEn] = useState("");
	const [secondTitleEn, setSecondTitleEn] = useState("");
	const [thirdTitleEn, setThirdTitleEn] = useState("");
	const [firstDescription, setFirstDescription] = useState("");
	const [secondDescription, setSecondDescription] = useState("");
	const [thirdDescription, setThirdDescription] = useState("");
	const [firstDescriptionEn, setFirstDescriptionEn] = useState("");
	const [secondDescriptionEn, setSecondDescriptionEn] = useState("");
	const [thirdDescriptionEn, setThirdDescriptionEn] = useState("");
	const [loading, setLoading] = useState(true);
	const [picture, setPicture] = useState(userPlaceholder);
	const [pictureMeta, setPictureMeta] = useState("");
	let editor = null;
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل البيانات",
				breadcrumb: "البيانات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			// .get(`${process.env.REACT_APP_API_URL}/posts/${informationId}`, {
			.get(`${process.env.REACT_APP_API_URL}/posts/about_us_info/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setFirstTitle(
					response.data.data[0].categories[0].posts[0].data.firstTitle.ar
				);
				setSecondTitle(
					response.data.data[0].categories[0].posts[0].data.secondTitle.ar
				);
				setThirdTitle(
					response.data.data[0].categories[0].posts[0].data.thirdTitle.ar
				);

				setFirstTitleEn(
					response.data.data[0].categories[0].posts[0].data.firstTitle.en
				);
				setSecondTitleEn(
					response.data.data[0].categories[0].posts[0].data.secondTitle.en
				);
				setThirdTitleEn(
					response.data.data[0].categories[0].posts[0].data.thirdTitle.en
				);

				setFirstDescription(
					response.data.data[0].categories[0].posts[0].data.firstDescription.ar
				);
				setSecondDescription(
					v =>
						(v =
							response.data.data[0].categories[0].posts[0].data
								.secondDescription?.ar)
				);
				setThirdDescription(
					response.data.data[0].categories[0].posts[0].data.thirdDescription.ar
				);

				setFirstDescriptionEn(
					v =>
						(v =
							response.data.data[0].categories[0].posts[0].data.firstDescription
								.en)
				);

				setSecondDescriptionEn(
					response.data.data[0].categories[0].posts[0].data.secondDescription.en
				);
				setThirdDescriptionEn(
					response.data.data[0].categories[0].posts[0].data.thirdDescription.en
				);
				setPicture(response.data.data[0].categories[0].posts[0].data.image);
				setPictureMeta(
					response.data.data[0].categories[0].posts[0].data.imageMeta
				);

				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		setLoading(true);
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
		const data = new FormData();
		data.append("file", fileInput.files[0]);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/admincp/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setPicture(response.data.data.name);
				setLoading(false);
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (
			!firstTitle ||
			!firstDescription ||
			!firstTitleEn ||
			!firstDescriptionEn ||
			!secondTitle ||
			!secondDescription ||
			!secondTitleEn ||
			!secondDescriptionEn ||
			!thirdTitle ||
			!thirdDescription ||
			!thirdTitleEn ||
			!thirdDescriptionEn
		) {
			return toast.error("جميع البيانات مطلوبة");
		}

		setLoading(true);
		const data = {
			firstTitle: {
				ar: firstTitle,
				en: firstTitleEn,
			},

			firstDescription: {
				ar: firstDescription,
				en: firstDescriptionEn,
			},
			secondTitle: {
				ar: secondTitle,
				en: secondTitleEn,
			},

			secondDescription: {
				ar: secondDescription,
				en: secondDescriptionEn,
			},
			thirdTitle: {
				ar: thirdTitle,
				en: thirdTitleEn,
			},

			thirdDescription: {
				ar: thirdDescription,
				en: thirdDescriptionEn,
			},

			image: picture,
			imageMeta: pictureMeta,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/275`,
				{
					admin_id: auth.id,
					category_id: 35,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				
				history.push("/aboutPage/information/show");
				toast.success("تم تحديث المقدمه بنجاح!");
                 
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-header"> البيان الاول</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										value={firstTitle}
										onChange={e => setFirstTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">الوصف</label>
								
									<CKEditor
										data={firstDescription}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setFirstDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزيه </label>
									<input
										type="text"
										id="title"
										onChange={e => setFirstTitleEn(e.target.value)}
										value={firstTitleEn}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> الوصف بالانجليزيه</label>
									
									<CKEditor
										data={firstDescriptionEn}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setFirstDescriptionEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
										}}
									/>
								</div>
							</div>
						</div>
						{/* ********************************************************************* */}
						<div className="card">
							<div className="card-header"> البيان الثاني</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										value={secondTitle}
										onChange={e => setSecondTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									
									<CKEditor
										data={secondDescription}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setSecondDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزيه </label>
									<input
										type="text"
										id="title"
										onChange={e => setSecondTitleEn(e.target.value)}
										value={secondTitleEn}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> الوصف بالانجليزيه</label>
							
									<CKEditor
										data={secondDescriptionEn}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setSecondDescriptionEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
										}}
									/>
								</div>
							</div>
						</div>
						{/* ********************************************************************* */}
						<div className="card">
							<div className="card-header"> البيان الثالث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										value={thirdTitle}
										onChange={e => setThirdTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">الوصف</label>
								
									<CKEditor
										data={thirdDescription}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setThirdDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزيه </label>
									<input
										type="text"
										id="title"
										onChange={e => setThirdTitleEn(e.target.value)}
										value={thirdTitleEn}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> الوصف بالانجليزيه</label>
								
									<CKEditor
										data={thirdDescriptionEn}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setThirdDescriptionEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
										}}
									/>
								</div>
							</div>
						</div>
						{/* ********************************************************************* */}
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">الصوره</label>
									<div className="form-item ">
										<input
											type="text"
											id="pictureMeta"
											onChange={e => setPictureMeta(e.target.value)}
											value={pictureMeta}
											placeholder={"ادخل وصف الصوره"}
										/>
									</div>
									<input type="file" onChange={handlePicture} id="picture" />
									 {picture && (
										 <div className="img-holder" >
											<img
										src={`${process.env.REACT_APP_MAIN_URL}${picture}`}
										alt="avatar"
										className="imagePreview"
									/>
									</div>
									 )}

								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default InformationShow;
